<template>
    <div>
        <div v-if="isProtected" v-b-tooltip.hover
            :title="infoHelper" placement="top"
            effect="dark">
            <div class="d-flex align-items-center text-muted">
                <i class="fa fa-lock"></i>
                <span class="ml-2" v-text="name"></span>
            </div>
        </div>
        <span v-else v-text="name"></span>
    </div>
</template>

<script>

export default {
    name: 'GuardIsProtected',
    props: {
        isProtected: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        },
        infoHelper: {
            type: String,
            default: 'Sección protegida, no puedes realizar acciones sobre las columnas de esta sección'
        }
    }
}

</script>